<template>
    <a class="suspend" id="searchBar" v-bind:class="btnFlag"  href="https://assistant.tuolele.cn/index.html"  target="view_windo">
        <img :src="Suspend" alt="大学生网上兼职">
    </a>
</template>

<script>
import Suspend from '../../assets/img/suspend.png'

export default {
    data () {
        return {
            Suspend,
            // btnFlag: '',
            scrollTop:0 //当前滑动距离
        }
    },
    props: {
        btnFlag: String
    }
    // mounted() {
    //     window.addEventListener('scroll', this.scrollToTop, true)
    // },
    // methods: {
    //     scrollToTop () {  
    //         var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //         if (scrollTop > 3220) {
    //             this.btnFlag = 'active'
    //         } else {
    //             this.btnFlag = ''
    //         }
    //     }
    // }
}
</script>

<style lang='scss'>
.suspend {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: -5px;
}

.active {
    position: absolute;
    // top: -181px;
    bottom: -251px;
}

.actives {
    position: absolute;
    bottom: -210px;
}
</style>


// WEBPACK FOOTER //
// src/components/suspend/suspend.vue